import { NgModule } from '@angular/core';
import { PreviewAnyFile } from '@awesome-cordova-plugins/preview-any-file/ngx';

@NgModule({
  providers: [PreviewAnyFile],
})
export class FileViewerModule {}
